
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import FormLabel from './form-label'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formlabel"
    }}>{`FormLabel`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "label"
    }}>{`Label`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`A caption for a form input. Include a label with all form inputs (except buttons).
FormLabels are programmatically linked to the corresponding input, which increases the hit area and provides information to screenreaders.`}</p>
    <Playground __position={1} __code={'<FormLabel text=\"Label\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormLabel
    }} mdxType="Playground">
  <FormLabel text="Label" mdxType="FormLabel" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "label-inverse"
    }}>{`Label (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`A caption for a form input. Include a label with all form inputs (except buttons).
FormLabels are programmatically linked to the corresponding input, which increases the hit area and provides information to screenreaders.`}</p>
    <Playground __position={3} __code={'<FormLabel inverse text=\"Label\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormLabel
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <FormLabel inverse text="Label" mdxType="FormLabel" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "label--tag"
    }}>{`Label + Tag`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For indicating the status of a form input, for example if it is required or optional.`}</p>
    <Playground __position={5} __code={'<FormLabel text=\"Label\" tag=\"Tag\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormLabel
    }} mdxType="Playground">
  <FormLabel text="Label" tag="Tag" mdxType="FormLabel" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "label--tag-inverse"
    }}>{`Label + Tag (inverse)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For indicating the status of a form input, for example if it is required or optional.`}</p>
    <Playground __position={7} __code={'<FormLabel inverse text=\"Label\" tag=\"Tag\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormLabel
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <FormLabel inverse text="Label" tag="Tag" mdxType="FormLabel" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormLabel} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;